import * as React from 'react';

import { Typography } from '@nelnet/unifi-components-react';

import UnifiTheme from '../../themes/unifi/UnifiTheme';

interface IPageIntroProps {
  title: string;
  intro?: string | React.ReactNode;
  version?: string;
  path?: string;
}

const PageIntro: React.FunctionComponent<IPageIntroProps> = ({ title, intro, version }) => {
  const introVariant = title.includes('Theme') ? 'body2' : 'subtitle1';

  return (
    <UnifiTheme>
      <div id="intro">
        <Typography variant="h1" gutterBottom={!version} tabIndex={-1}>
          {title}
        </Typography>
        {version && (
          <Typography
            variant="overline"
            color="textSecondary"
            display="block"
            margin={{ top: 1, bottom: 3 }}
          >
            Version: {version}
          </Typography>
        )}
        {intro && typeof intro === 'string' ? (
          <Typography variant={introVariant} margin={{ bottom: 3 }}>
            <span dangerouslySetInnerHTML={{ __html: intro }} />
          </Typography>
        ) : (
          <Typography variant={introVariant} component="div" margin={{ bottom: 3 }}>
            {intro}
          </Typography>
        )}
      </div>
    </UnifiTheme>
  );
};

export default PageIntro;
